import { ActKC2CostGroup } from 'pages/Project/Common/types';
import { formatDateToLocale, formatNumberToRu } from 'utils';

type TMaybe<T> = T | null | undefined;

export const getColSpan = <T extends { isGroup?: boolean }>({ data }: { data: TMaybe<T> }) => (data?.isGroup ? 5 : 1);

export const costCellFormatter = <
    T extends { costWithoutTax?: number; groupCostWithoutTax?: number; isGroup?: boolean },
>({
    data,
}: {
    data: TMaybe<T>;
}) => {
    if (data?.isGroup) {
        return formatNumberToRu(data?.groupCostWithoutTax, 2);
    }

    return formatNumberToRu(data?.costWithoutTax, 2);
};

export const costGroupFormatter = <T extends { costGroup?: TMaybe<keyof typeof ActKC2CostGroup> }>({
    data,
}: {
    data: TMaybe<T>;
}) => (data?.costGroup ? ActKC2CostGroup[data.costGroup] : '');

export const dateFormatter =
    <T extends Partial<Record<K, any>>, K extends keyof T = keyof T>(key: K) =>
    ({ data }: { data: TMaybe<Partial<T>> }) =>
        data ? formatDateToLocale(data?.[key]) : '';
